import { 
  LoginModel, 
} from './login.model';

import { 
  BaseClass,
  dropProps,
} from '../Base/base.class';

import { InputClass } from '../Form/InputField/input.class';

import { InputModel } from '../Form/InputField/input.model';

import { loginFormData } from './login.data';

export class LoginClass extends BaseClass<LoginModel> implements LoginModel {
  get email(): InputModel {
    return dropProps(this.props.email, new InputClass(this.props.email)); 
  }
  get password(): InputModel {
    return dropProps(this.props.password, new InputClass(this.props.password));
  }
}

export const loginFormValues = () => loginFormData && dropProps(loginFormData(), new LoginClass(loginFormData()));
